import { useUploadStore } from '../../../../../../../store/uploadStore';
import getPilotApiService from '../../../../../../../api_services/PilotApiService';
import { MissionCustomer, ScheduledFlight, Site } from '../../../../../../../types';
import { trackAction } from '../../../../../../../libs/analytics/ActionTracking';

export const useHandleUploadCancel = (
  isPano: boolean,
  customer: MissionCustomer,
  site: Site,
  schedule?: ScheduledFlight,
  cancelGeoRef = true,
) => {
  const { getRegistrationRequests, getGeoref, setGeoref, getUpload, clearRegistrationRequests, setUpload } =
    useUploadStore();

  return () => {
    const upload = getUpload(isPano, customer.id, site.id, schedule?.airtableRecordId);
    const georef = getGeoref(customer.id, site.id, schedule?.airtableRecordId);

    trackAction('Remove georef file', { customer, site });

    const registrationRequests = getRegistrationRequests(isPano, customer.id, site.id, schedule?.airtableRecordId);
    registrationRequests?.forEach((r) => r.abortController.abort());
    clearRegistrationRequests(isPano, customer.id, site.id, schedule?.airtableRecordId);

    if (georef) {
      georef.meta.isRegistrationRequestSent = false;
      setGeoref(customer.id, site.id, schedule?.airtableRecordId, { ...georef });
    }

    if (georef && cancelGeoRef) {
      // For georef besides registration requests we also have to cancel upload and parsing
      georef.meta.abortController.abort();
      setGeoref(customer.id, site.id, schedule?.airtableRecordId, undefined);
    }

    if (upload) {
      upload.meta.abortController.abort();
      setUpload(isPano, customer.id, site.id, schedule?.airtableRecordId, undefined);
      getPilotApiService().cancelIntake(
        customer.id,
        site.id,
        upload.meta.type,
        upload.overview.date,
        upload.overview.flightScheduleId,
      );
    }
  };
};
